const initialState = {
    ids: '',
};

export default function leads_statuses_fetch(state = initialState, action) {
    switch (action.type) {
        case 'SET_LEADS_STATUSES_FETCH_IDS':
            return {
                ...state,
                ids: action.value,
            };
        default:
            return state;
    }
}
